import { render, staticRenderFns } from "./TaskbarToolbar.vue?vue&type=template&id=a48e93ea&scoped=true"
import script from "./TaskbarToolbar.vue?vue&type=script&lang=js"
export * from "./TaskbarToolbar.vue?vue&type=script&lang=js"
import style0 from "./TaskbarToolbar.vue?vue&type=style&index=0&id=a48e93ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48e93ea",
  null
  
)

export default component.exports